import { FromDistribution, SanitizedAssigneeSelection } from '@chilipiper/api-client/src/edge-fire'
import {
  PickedMeetingLocation,
  ScheduleMeetingRequestPublic,
} from '@chilipiper/api-client/src/handoff'
import { getSecondaryFeature } from '../../load-meeting-attempt/helpers/product-feature'

export const isFromDistributionAssignee = (
  assignee: SanitizedAssigneeSelection
): assignee is { type: 'FromDistribution' } & FromDistribution =>
  assignee.type === 'FromDistribution'

export const getHandoffWithReservationPayload = ({
  reservationId,
  selectedAssignees,
  timezone,
  location = { type: 'DefinedInMeetingType' },
  pathname,
}: {
  selectedAssignees: Exclude<SanitizedAssigneeSelection, { type: 'FromDistribution' }>[]
  location: PickedMeetingLocation
  pathname: string
  reservationId: string
  timezone?: string
}) => {
  const assignees = selectedAssignees.map(assignee => {
    if (assignee.type === 'User') {
      return {
        type: 'User' as const,
        id: assignee.id,
      }
    }

    if (assignee.type === 'UserFromDistribution') {
      return {
        type: 'User' as const,
        id: assignee.user,
      }
    }

    // For 'FromDistribution' type, we need to handle it without ScheduleByReservation and use ScheduleByDistribution instead
    // and thus this function should not be called for 'FromDistribution' type
    throw new Error(
      `Unsupported assignee type for reservation: FromDistribution | reservationId: ${reservationId}`
    )
  })

  const payload: ScheduleMeetingRequestPublic = {
    type: 'ScheduleByReservation',
    assigneeId: assignees[0]?.id,
    assignees,
    reservationId,
    guestTimezone: timezone,
    location,
    secondaryFeature: getSecondaryFeature(pathname, true),
  }

  return payload
}
